import $ from 'jquery';

export function dashboardMenu() {
  function isMobile() {
    return $(window).width() < 991;
  }

  var sidebarNav = $('.sidebar-nav');
  var wasExpanded = sidebarNav.hasClass('expanded'); 

  function handleResize() {
    if (isMobile()) {
      sidebarNav.removeClass('expanded'); 
    } else if (wasExpanded) {
      sidebarNav.addClass('expanded'); 
    }
    if (!isMobile()) {
      $('body').removeClass('overlay'); 
    }
  }

  handleResize();

  $('.sidebar__toggle').click(function() {
    if (isMobile()) {
      sidebarNav.removeClass('expanded');
      $('body').removeClass('overlay');
    } else {
      sidebarNav.toggleClass('expanded');
    }
  });

  $('.mobile__toggle').click(function() {
    if (isMobile()) {
      sidebarNav.addClass('expanded');
      $('body').addClass('overlay');
    }
  });

  // Cerrar el sidebar al hacer clic en un link del tray (en móvil)
  $(document).on('click', '.tray__link', function() {
    if (isMobile()) {
      sidebarNav.removeClass('expanded');
      $('body').removeClass('overlay');
    }
  });

  // Cerrar el sidebar al tocar el overlay (fuera del sidebar) en móvil
  $(document).on('click', function(e) {
    if (isMobile() && $('body').hasClass('overlay')) {
      if (!$(e.target).closest('.sidebar-nav, .mobile__toggle').length) {
        sidebarNav.removeClass('expanded');
        $('body').removeClass('overlay');
      }
    }
  });

  $(window).resize(handleResize);
}